
export const handleKeyDown = (e) =>{
    const keyCode = e?.which || e?.keyCode;
    if (keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
    return true;
}